import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import PersonnelList from '../components/PersonnelList';
import PersonnelDetail from '../components/PersonnelDetail';
import AddPersonnelModal from '../components/AddPersonnelModal';
import API_BASE from '../config/api';

export default function Personnel() {
  const { token } = useAuth();
  const { activeWorkspace } = useWorkspace();
  const [personnel, setPersonnel] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    if (!token) { setIsLoading(false); return; }
    setIsLoading(true);
    axios
      .get(`${API_BASE}/api/personnel?workspace_id=${activeWorkspace?._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => { setPersonnel(res.data); setIsLoading(false); })
      .catch(() => setIsLoading(false));
  }, [token, activeWorkspace?._id]);

  const filtered = personnel.filter((p) => {
    const fullName = `${p.first_name || ''} ${p.last_name || ''}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  async function handleAdded(newProfile) {
    try {
      const res = await axios.get(`${API_BASE}/api/personnel?workspace_id=${activeWorkspace?._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPersonnel(res.data);
      setSelectedProfile(res.data.find((p) => p._id === newProfile._id) || null);
    } catch {
      setPersonnel((prev) =>
        [...prev, newProfile].sort((a, b) =>
          (a.last_name || '').localeCompare(b.last_name || '')
        )
      );
      setSelectedProfile(newProfile);
    }
  }

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 56px)', marginTop: '56px', backgroundColor: '#222222' }}>
      <PersonnelList
        personnel={filtered}
        selectedId={selectedProfile?._id}
        onSelect={setSelectedProfile}
        onAdd={() => setShowAddModal(true)}
        isLoading={isLoading}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
      <PersonnelDetail
        profile={selectedProfile}
        onUpdate={(updated) =>
          setPersonnel((prev) => prev.map((p) => p._id === updated._id ? updated : p))
        }
      />
      <AddPersonnelModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={handleAdded}
      />
    </div>
  );
}
